<template>
  <v-card id="app-bug-msg" v-show="showAppBugMsg">
        <i18n path="notification.info.text" tag="span" id="info-popup">
          <template v-slot:date>
            [<span id="date-section">{{ $t('notification.info.date')}}</span>]
          </template>
        </i18n>
    <v-btn flat icon color="info" v-on:click="showAppBugMsg = !showAppBugMsg">
      <v-icon dark>close</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
export default {
  name: 'BottomInfoPopup',
  data () {
    return {
      showAppBugMsg: true
    }
  }
}
</script>

<style scoped>
#app-bug-msg {
  background-color: #5e5e5e;
  color: white;
  position: absolute;
  bottom: 0;
  z-index: 1000;
  width: 75vw;
  left: 12.5vw;
  border-radius: 8px;
  display: flex;
}
#info-popup {
  flex-grow: 5;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/InfoPopup.vue